import { useEffect, useState } from 'react';

import Revenue from '@/pages/Revenue';
import UnregisteredCustomers from '@/pages/UnregisteredCustomers';
import profileService from '@/services/profile.service';

export const IndexRoute = () => {
    const [user, setUser] = useState<any>({});

    const getUser = async () => {
        const result = await profileService.get();
        setUser(result);
    };

    useEffect(() => {
        getUser();
    }, []);

    if (user?.roleLevel === 0) {
        return <UnregisteredCustomers />;
    }

    return <Revenue />;
};
